import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const H1TextContent = ({
  textContent
}) => {
  return /*#__PURE__*/_jsx("span", {
    className: "m-right-1",
    children: textContent !== '' ? textContent : /*#__PURE__*/_jsx("i", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.placeholders.FIX_H1_TAGS.emptyElement"
      })
    })
  });
};